import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static targets = ["csvUpload", "xColumn", "yColumns"]
  static values = { columnsByUpload: Object }

  connect() {
    this.yChoices = new Choices(this.yColumnsTarget, {
      removeItemButton: true,
      duplicateItemsAllowed: false,
      shouldSort: true,
      searchResultLimit: -1,
      fuseOptions: {
        threshold: 0.3,
        minMatchCharLength: 1
      }
    })
  }

  refresh() {
    const options = this.columnsByUploadValue[this.csvUploadTarget.value] || []
    const previousY = this.yChoices.getValue(true)

    this.repopulateNative(this.xColumnTarget, options, this.xColumnTarget.value)

    this.yChoices.clearStore()
    this.yChoices.setChoices(
      options.map(([label, value]) => ({ value, label, selected: previousY.includes(value) })),
      "value",
      "label",
      true
    )
  }

  repopulateNative(select, options, previousValue) {
    select.innerHTML = ""
    select.appendChild(new Option("", ""))

    options.forEach(([label, value]) => {
      const option = new Option(label, value)
      option.selected = value === previousValue
      select.appendChild(option)
    })
  }

  disconnect() {
    if (this.yChoices) {
      this.yChoices.destroy()
      this.yChoices = null
    }
  }
}
